<settings-page-layout>
  <div class="page__container">
    <div class="page__header">
      <p class="page__title">Integrations</p>
    </div>
    <p class="page__description">
      Connect your favorite tools to extend PDQ with custom workflows, widgets, and automations
    </p>
    <pdq-card color="white" variant="popover">
      <div class="page__list">
        @for (integrationItem of integrationList; track integrationItem) {
          <integration-item [integration]="integrationItem"></integration-item>
        }
        @for (integrationItem of comingSoonIntegrations; track integrationItem) {
          <integration-item disabled="true" [integration]="integrationItem"></integration-item>
        }</div
    ></pdq-card>
  </div>
  <footer>
    <p>Need another integration? Let us know at</p>
    <pdq-link label="support@prettydamnquick.com" url="mailto:support@prettydamnquick.com"></pdq-link>
  </footer>
</settings-page-layout>
